import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ScepServerInfo, SCEP_USAGE_APP, SCEP_USAGE_EAP_ETHERNET, SCEP_USAGE_EAP_WIFI, SCEP_USAGE_VPN } from '../scep.data';
import { ScepService } from '../scep.service';
import { AutoUnsubscribeComponent } from 'app/content/virtual/auto-unsubscribe.component';

@Component({
    selector: 'na-scep-server-detail',
    templateUrl: './scep-server-detail.component.html',
    styleUrls: ['../scep.style.css', './scep-server-detail.component.css']
})
export class SCEPServerDetailComponent extends AutoUnsubscribeComponent {
    readonly SCEP_ALIAS_PREFIX: string = this.scepSvc.SCEP_ALIAS_PREFIX;

    _editData: ScepServerInfo;
    _scepUsageList: string[] = [SCEP_USAGE_APP, SCEP_USAGE_VPN, SCEP_USAGE_EAP_ETHERNET, SCEP_USAGE_EAP_WIFI];

    @Input('scep')  _scep: ScepServerInfo;
    @Input('mode') _mode: string = 'update';
    @Input('disabled') _disabled: boolean = false;

    _isInEdit: boolean = false;
    @Input('isInEdit')
    set isInEdit(v: boolean) {
        this._isInEdit = v;
        this._editData = this._isInEdit ? this._scep.copy() : new ScepServerInfo();
    }

    private _colAliasRef: ElementRef;
    @ViewChild('colAlias', { static: false })
    set colAlias(v: ElementRef) {
        if (v) {
            this._colAliasRef = v;

            this.trackInputEvent(this._colAliasRef.nativeElement).subscribe((e: any) => {
                this._editData.alias = e.target.value;
                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }

    private _colSubjectRef: ElementRef;
    @ViewChild('colSubject', { static: false })
    set colSubject(v: ElementRef) {
        if (v) {
            this._colSubjectRef = v;

            this.trackInputEvent(this._colSubjectRef.nativeElement).subscribe((e: any) => {
                this._editData.subject = e.target.value;
                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }

    private _colUrlRef: ElementRef;
    @ViewChild('colUrl', { static: false })
    set colUrl(v: ElementRef) {
        if (v) {
            this._colUrlRef = v;

            this.trackInputEvent(this._colUrlRef.nativeElement).subscribe((e: any) => {
                this._editData.url = e.target.value;
                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }

    private _colKeysizeRef: ElementRef;
    @ViewChild('colKeysize', { static: false })
    set colKeysize(v: ElementRef) {
        if (v) {
            this._colKeysizeRef = v;

            this.trackInputEvent(this._colKeysizeRef.nativeElement).subscribe((e: any) => {
                try {
                    const keysizeUInt: number = parseInt(e.target.value);
                    this._editData.keysize = keysizeUInt;
                }
                catch {

                }

                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }

    private _colProfileRef: ElementRef;
    @ViewChild('colProfile', { static: false })
    set colProfile(v: ElementRef) {
        if (v) {
            this._colProfileRef = v;

            this.trackInputEvent(this._colProfileRef.nativeElement).subscribe((e: any) => {
                this._editData.profile = e.target.value;
                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }

    private _colRenewRef: ElementRef;
    @ViewChild('colRenew', { static: false })
    set colRenew(v: ElementRef) {
        if (v) {
            this._colRenewRef = v;

            this.trackInputEvent(this._colRenewRef.nativeElement).subscribe((e: any) => {
                this._editData.autoRenewDay = parseInt(e.target.value);
                this.onScepInfoUpdated.emit(this._editData);
            });
        }
    }


    @Output() onScepInfoUpdated = new EventEmitter<ScepServerInfo>();

    constructor(private scepSvc: ScepService) {
        super();
    }

    changeScepUsage(usage: string): void {
        if (this._editData.usage !== usage) {
            this._editData.usage = usage;
            this.onScepInfoUpdated.emit(this._editData);
        }
    }

    private trackInputEvent(inputEle: HTMLElement, debounce: number = 200): Observable<any> {
        return fromEvent(inputEle, 'input').pipe(
            debounceTime(debounce),
            takeUntil(this._unsubscribe$)
        );
    }
}